import { PerformerItemDto } from '../../core';
import { applyMovementOfRanking } from '../function/determine-movement-of-ranking.function';
import { PerformerItemView } from '../model/performer-item-view.model';

export function performerItemViewTransformer(
    items: PerformerItemDto[],
): PerformerItemView[] {
    return items?.map((e) => {
        const next: PerformerItemView = { ...e };
        next.name = `${e.userFirstName} ${e.userLastName}`;
        applyMovementOfRanking(next);
        return next;
    });
}
